import ProviderLanguage from "@wtw/company-portal/lib/i18n/ProviderLanguage";

export function initializeProviderLanguage() {
    (window as any).providerLanguage = {
        en: require('./locales/en.json'),
        // se: require('./locales/se.json'),
        no: require('./locales/no.json')
    } as ProviderLanguage;
}